export default (params: number) =>`${params.toLocaleString()} CFA`